import objectFitImages from 'object-fit-images'
import SmoothScroll from 'smooth-scroll'
import navigation from './utility/navigation'
import Aos from 'aos'

import Vue from 'vue'
import Slick from 'vue-slick'



/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */

// Aos -------------------------------------------------

const aosAnimation = () => Aos.init({
  offset: 0,
  delay: 0,
  duration: 500,
  easing: 'ease-in',
  once: true,
  mirror: false,
  anchorPlacement: 'top-bottom',
});
aosAnimation()


// objectFitImages -------------------------------------------------

objectFitImages()



// SmoothScroll -------------------------------------------------

var scroll = new SmoothScroll('a[href*="#"]', {
  speed:           200,
  speedAsDuration: false,
  easing:          'Linear',
  updateURL: false,
  offset: (toggle) => {
    if (toggle.classList.contains('footer__allow')) {
      return 0;
    } else {
      return 42;
    }
  }
});


/* -------------------------------------------------------------------
  navigation
------------------------------------------------------------------- */

navigation('header-navBtn', 'header')



/* -------------------------------------------------------------------
  mainSlider
------------------------------------------------------------------- */

if (document.getElementById('mainSlider')) {
  const mainSlider = new Vue({
    el: "#mainSlider",
    data() {
      return {
        state : 1,
        stateBefore: 3,
        stateAfter: 2,
        count: 0,
        max: 1,
        speed: 8000
      }
    },
    mounted(){
      this.max = document.querySelectorAll('.top-main__img').length
      setInterval( () => {
        this.stateChange()
      }, this.speed)
    },
    methods: {
      stateChange(){
        if(this.state < this.max){
          this.stateBefore = this.state
          this.state       += 1
        }else{
          this.stateBefore = this.state
          this.state       = 1
        }
        this.stateAfter  =  this.state == this.max ? 1 : this.state+1
      },
    },
    watch: {
      state() {
        const before = this.$el.children[this.stateBefore-1]
        const after  = this.$el.children[this.stateAfter-1]
        const state  = this.$el.children[this.state-1]

        before.classList.remove('on')
        before.classList.remove('on-after')
        before.classList.add('off')

        after.classList.remove('on')
        after.classList.remove('off')
        after.classList.add('on-after')

        state.classList.remove('off')
        state.classList.remove('on-after')
        state.classList.add('on')
        setTimeout( () => {
          before.classList.remove('off')
          after.classList.remove('on-after')
        }, this.speed)
      },
    }
  })
}


/* -------------------------------------------------------------------
  worksGallery
------------------------------------------------------------------- */

if (document.getElementById('worksGallery')) {
  const worksGallery = new Vue({
    el: "#worksGallery",
    components: {
      Slick,
    },
    data() {
      return {
        slickOptions: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          infinite: true,
          dots: true,
          speed: 500,
          fade: true,
          centerMode: true,
          prevArrow: '<span class="btn__allow short prev"><span class="btn__allow--img"></span>PREV</span>',
          nextArrow: '<span class="btn__allow short next"><span class="btn__allow--img"></span>NEXT</span>',
          responsive: [
            {
              breakpoint: 599,
              settings: {
                nextArrow: '<span class="arrow next"><i class="icon-right"></i></span>',
                prevArrow: '<span class="arrow prev"><i class="icon-left"></i></span>',
              }
            },
          ]
        },
      }
    },
    mounted() {
      aosAnimation()
    },
    methods: {
      next() {
        this.$refs.slick.next()
      },
      prev() {
        this.$refs.slick.prev()
      },
      reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
          this.$refs.slick.reSlick()
          aosAnimation()
        })
      },
    },
  })
}
